import React, { Suspense, useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { LocationProvider } from './Uitiles/LocationProvider';
import { initializeSettings } from './services/settingsCSS';
import { initializeDatabase } from './services/settingsService';
import NotFound from './components/NotFound';
import FrontendLayout from './layouts/Frontend/FrontendLayout';

// Import route files
import frontendRoutes from './routes/frontendRoutes';
import doctorRoutes from './routes/doctorRoutes';
import hospitalRoutes from './routes/hosptalRoutes';
import adminRoutes from './routes/adminRoutes';
import userRoutes from './routes/userRoutes';
import printRoutes from './routes/printRoutes';
import pharmacyMacRoutes from './routes/pharmacyMac';
import PharmacyRoutes from './routes/PharmacyRoutes';
import staffRoutes from './routes/staffRoutes';
import { getSettings } from './services/settingsService';
import { SettingsProvider } from './context/SettingsContext';
import newTheamRoutes from './routes/NewTheamRoutes';
import insuranceRoutes from './routes/insuranceRoutes';
import bloodBankRoutes from './routes/bloodBankRoutes';
import diagnosticRoutes from './routes/diagnosticRoutes';

// Loading component - Test for hot reloading
const LoadingFallback = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>Loading... (Hot reload test)</p>
  </div>
);

function App() {
  // Initialize settings on app startup
  const [settings, setSettings] = useState({});
  useEffect(() => {
    const initializeApp = async () => {
      try {
        console.log('Initializing app...');
        // First initialize database
        await initializeDatabase();
        // Then initialize settings
        await initializeSettings();
        console.log('App initialization complete');
      } catch (error) {
        console.error('Error initializing app:', error);
      }
    };

    initializeApp();
  }, []);

  useEffect(() => {
    getSettings().then(settings => {
      setSettings(settings);
    });
  }, []);

  return (
    <Router>
      <SettingsProvider>
        <HelmetProvider>
          <AuthProvider>
            <CurrencyProvider>
              <LocationProvider>
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    {/* Frontend routes */}
                    {frontendRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Doctor routes */}
                    {doctorRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Hospital routes */}
                    {hospitalRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* User routes */}
                    {userRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Insurance routes */}
                    {insuranceRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Blood Bank routes */}
                    {bloodBankRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Diagnostic routes */}
                    {diagnosticRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Admin routes */}
                    {adminRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Print routes */}
                    {printRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Pharmacy routes */}
                    {pharmacyMacRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Pharmacy routes */}
                    {PharmacyRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* Staff routes */}
                    {staffRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                    {/* New theam routes */}
                    {newTheamRoutes.map((route, index) => (
                      <Route key={index} path={route.path} element={route.element} />
                    ))}

                  </Routes>
                </Suspense>
              </LocationProvider>
            </CurrencyProvider>
          </AuthProvider>
        </HelmetProvider>
      </SettingsProvider>
    </Router>
  );
}
export default App;
